import React from 'react';
import PropTypes from 'prop-types';
import parseV3000SumFormula from '@Utils/React/MolFiletoFormula';
import { sanitizeDiscard } from '@Services/HtmlSanitizeService';

function StructureThumbnail({ enableThumbnail, thumbnailPath, structure, structureName }) {
  const formula = parseV3000SumFormula(structure);
  const imgOnDragStart = (e) => {
    e.preventDefault();
  };

  if (!enableThumbnail) {
    return (
      <svg className="els-btn-icon els-btn-icon-md svg-icon">
        <use xlinkHref="#icon-structure" />
      </svg>
    );
  }

  if (enableThumbnail && !thumbnailPath) {
    return null;
  }

  // Determine alt text based on structureName type, parsed formula, or default
  let altText = 'chemical structure';
  if (structureName) {
    if (structureName.isLinearFormula) {
      altText = `Linear formula of ${sanitizeDiscard(structureName.name, { allowedTags: [] })}`;
    } else if (typeof structureName === 'string') {
      altText = `chemical structure of ${sanitizeDiscard(structureName, { allowedTags: [] })}`;
    }
  } else if (formula?.trim()) {
    altText = `Linear formula of ${sanitizeDiscard(formula, { allowedTags: [] })}`;
  }

  return <img alt={altText} src={thumbnailPath} draggable="false" onDragStart={imgOnDragStart} />;
}

StructureThumbnail.propTypes = {
  enableThumbnail: PropTypes.bool,
  thumbnailPath: PropTypes.string,
  structure: PropTypes.string,
  structureName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default StructureThumbnail;
